export default __webpack_public_path__ + "static/media/oferecemosmob.3e83f268.png";